<template>
  <div>
    {{ !settingsSessionObj || !settingsSessionObj.name ? "Please set the Name of this Cam in Settings":
      `Cam Name:${settingsSessionObj.name}`
    }}
    <video
        v-if="false"
        id="localVideo" autoplay></video>
    <div id="currentRoom">{{ currentRoom }}</div>
    {{ localStream ? 'STREAMING VIDEO':""}}


    <video id="remoteVideo" autoplay></video>
    <b-button
      id="activate-btn"
      variant="primary"
      style="margin-left: 15px"
      @click="handleActivateCam"
      :disabled="activateDisabled"
    >
      Activate Cam
    </b-button>
    <b-button
        id="hangupBtn"
        variant="primary"
        style="margin-left: 15px"
        :disabled="disconnectDisabled"
        @click="hangUp">
      Disconnect
    </b-button>
  </div>
</template>

<script>
import firebase from "firebase";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
export default {
  name: "Display_PaneRTC",
  mixins: [ResourceBlockDisplay],
  mounted() {
    this.init();
    this.getConnectedDevices("videoinput", cameras =>
      console.log("Cameras found", cameras)
    );
    this.getConnectedDevices("audioinput", audios =>
      console.log("Cameras found", audios)
    );
  },
  props: {
    rootPathCollection: {
      type: String,
      default: "rtcs"
    }
  },
  computed: {
    localIcePath() {
      return this.roomId && this.rootPathCollection && this.idName
        ? `${this.rootPathCollection}/${this.roomId}/${this.idName}/ice/local`
        : null;
    },
    remoteIcePath() {
      return this.roomId && this.rootPathCollection && this.idName
        ? `${this.rootPathCollection}/${this.roomId}/${this.idName}/ice/remote`
        : null;
    },
    activateDisabled(){
      return !!(!this.localStream || !this.settingsSessionObj || !this.settingsSessionObj.name);
    },
    disconnectDisabled(){
      return !!(!this.peerConnection);
    },
  },
  methods: {
    async init() {
      //this.roomDialog = new mdc.dialog.MDCDialog(document.querySelector('#room-dialog'));
      // Add event listeners
      this.openUserMedia();
    },
    getConnectedDevices(type, callback) {
      navigator.mediaDevices.enumerateDevices().then(devices => {
        const filtered = devices.filter(device => device.kind === type);
        callback(filtered);
      });
    },
    handleActivateCam() {
      this.createRoom();
    },
    async createRoom() {
      const db = firebase.firestore();
      const roomRef = await db.collection(this.rootPathCollection).doc();

      console.log(
        "Create PeerConnection with configuration: ",
        this.configuration
      );
      this.peerConnection = new RTCPeerConnection(this.configuration);

      this.registerPeerConnectionListeners();

      this.localStream.getTracks().forEach(track => {
        this.peerConnection.addTrack(track, this.localStream);
      });

      const callerCandidatesCollection = roomRef.collection("callerCandidates");

      this.peerConnection.addEventListener("icecandidate", event => {
        if (!event.candidate) {
          console.log("Got final candidate!");
          return;
        }
        console.log("Got candidate: ", event.candidate);
        callerCandidatesCollection.add(event.candidate.toJSON());
      });

      const offer = await this.peerConnection.createOffer();
      await this.peerConnection.setLocalDescription(offer);
      console.log("Created offer:", offer);

      const roomWithOffer = {
        offer: {
          type: offer.type,
          sdp: offer.sdp
        }
      };
      await roomRef.set(roomWithOffer);
      this.roomId = roomRef.id;

      //Update the settings for this session
      this.updateDataWithCamId(this.roomId);

      console.log(`New room created with SDP offer. Room ID: ${roomRef.id}`);
      this.currentRoom = `Current room is ${roomRef.id} - You are the caller!`;

      this.peerConnection.addEventListener("track", event => {
        console.log("Got remote track:", event.streams[0]);
        event.streams[0].getTracks().forEach(track => {
          console.log("Add a track to the remoteStream:", track);
          this.remoteStream.addTrack(track);
        });
      });

      roomRef.onSnapshot(async snapshot => {
        const data = snapshot.data();
        if (
          !this.peerConnection.currentRemoteDescription &&
          data &&
          data.answer
        ) {
          console.log("Got remote description: ", data.answer);
          const rtcSessionDescription = new RTCSessionDescription(data.answer);
          await this.peerConnection.setRemoteDescription(rtcSessionDescription);
        }
      });

      roomRef.collection("calleeCandidates").onSnapshot(snapshot => {
        snapshot.docChanges().forEach(async change => {
          if (change.type === "added") {
            let data = change.doc.data();
            console.log(
              `Got new remote ICE candidate: ${JSON.stringify(data)}`
            );
            await this.peerConnection.addIceCandidate(
              new RTCIceCandidate(data)
            );
          }
        });
      });
    },
    updateDataWithCamId(camRTCId) {
      //Find Setting
      let sessionObj = this.getSessionObj();
      if (!sessionObj) {
        const newSessionObj = {
          camRTCId: camRTCId,
          name: this.settingsSessionObj ? this.settingsSessionObj.name : null,
          sessionId: this.sessionId,
          _created_at: new Date()
        };
        this.handleSaveSessionCam(newSessionObj);
      } else {
        sessionObj.camRTCId = camRTCId;
        sessionObj.name = this.settingsSessionObj
          ? this.settingsSessionObj.name
          : null;
        sessionObj._updated_at = new Date();
        //@TODO- Update
      }
    },
    handleSaveSessionCam(session) {
      let logs = {
        sessions: [session]
      };

      let notif = {
        title: `Contact Save`,
        description: `You have saved the session for this cam.`,
        variant: "success"
      };

      const payload = {
        userData: logs,
        notif: notif,
        key: "sessions"
      };
      this.handleUpdateUserData(payload);
    },
    async openUserMedia() {
      // Open user media logic
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true
      });
      this.localStream = stream;
      this.remoteStream = new MediaStream();

      /* Do not display video
       document.querySelector("#localVideo").srcObject = stream;
      document.querySelector("#remoteVideo").srcObject = this.remoteStream;
      console.log(
        "Local Stream:",
        document.querySelector("#localVideo").srcObject
      );*/
    },
    async hangUp() {
      // Hang up logic
    },
    registerPeerConnectionListeners() {
      this.peerConnection.addEventListener("icegatheringstatechange", () => {
        console.log(
          `ICE gathering state changed: ${this.peerConnection.iceGatheringState}`
        );
      });

      this.peerConnection.addEventListener("connectionstatechange", () => {
        console.log(
          `Connection state change: ${this.peerConnection.connectionState}`
        );
      });

      this.peerConnection.addEventListener("signalingstatechange", () => {
        console.log(
          `Signaling state change: ${this.peerConnection.signalingState}`
        );
      });

      this.peerConnection.addEventListener("iceconnectionstatechange ", () => {
        console.log(
          `ICE connection state change: ${this.peerConnection.iceConnectionState}`
        );
      });
    }
  },
  data() {
    return {
      roomId: null,
      idName: null,
      settingsUser: this.settings.user,
      peerConnection: null,
      localStream: null,
      remoteStream: new MediaStream(),
      roomDialog: null,
      currentRoom: "",
      configuration: {
        iceServers: [
          {
            urls: [
              "stun:stun1.l.google.com:19302",
              "stun:stun2.l.google.com:19302"
            ]
          }
        ],
        iceCandidatePoolSize: 10
      }
    };
  }
};
</script>
